<template>
  <MainLayout v-if="!isStandalonePage" />
  <router-view v-else />
</template>

<script>
import MainLayout from './layouts/MainLayout'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

export default {
  name: 'App',
  components: {
    MainLayout
  },
  setup() {
    const route = useRoute()
    const isStandalonePage = computed(() => route.meta.standalone === true)
    return { isStandalonePage }
  }
}
</script>
